(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  class LocalizationForm extends HTMLElement {

    constructor() {

      super();

      this.elements = {

        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),

        button: this.querySelector('button'),

        panel: this.querySelector('.disclosure__list-wrapper')

      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));



      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

    }



    hidePanel() {

      this.elements.button.setAttribute('aria-expanded', 'false');

      this.elements.panel.setAttribute('hidden', true);

    }



    onContainerKeyUp(event) {

      if (event.code.toUpperCase() !== 'ESCAPE') return;



      this.hidePanel();

      this.elements.button.focus();

    }



    onItemClick(event) {

      event.preventDefault();

      const form = this.querySelector('form');

      this.elements.input.value = event.currentTarget.dataset.value;

      if (form) form.submit();

    }



    openSelector() {

      this.elements.button.focus();

      this.elements.panel.toggleAttribute('hidden');

      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

    }



    closeSelector(event) {

      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

      if (event.relatedTarget === null || shouldClose) {

        this.hidePanel();

      }

    }

  }



  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._sbRecommendationsInitialized) return;
        this._sbRecommendationsInitialized = true;

        if (this.querySelector('.grid__item')) {
          this.reveal();
          return;
        }

        if ('IntersectionObserver' in window) {
          this._sbRecommendationsObserver = new IntersectionObserver((entries, observer) => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            observer.unobserve(this);
            this.loadRecommendations();
          }, { rootMargin: '0px 0px 500px 0px' });
          this._sbRecommendationsObserver.observe(this);
        } else {
          this.loadRecommendations();
        }
      }

      disconnectedCallback() {
        if (this._sbRecommendationsObserver) {
          this._sbRecommendationsObserver.disconnect();
        }
      }

      loadRecommendations() {
        if (this._sbRecommendationsLoading || !this.dataset.url) return;
        this._sbRecommendationsLoading = true;

        fetch(this.dataset.url, { credentials: 'same-origin' })
          .then(response => {
            if (!response.ok) throw new Error('Recommendations request failed');
            return response.text();
          })
          .then(text => {
            if (!this.isConnected) return;

            const html = new DOMParser().parseFromString(text, 'text/html');
            const fetchedElement = html.querySelector('product-recommendations');

            if (!fetchedElement || !fetchedElement.querySelector('.grid__item')) {
              return; // Shopify has no suggestions for this product.
            }

            this.innerHTML = fetchedElement.innerHTML;
            this.reveal();
            this.initializeReviews();
          })
          .catch(error => {
            console.warn('Product recommendations could not be loaded:', error);
          });
      }

      reveal() {
        this.classList.add('product-recommendations--loaded');
        const root = this.closest('[data-sb-recommendations-root]');
        if (root) root.classList.remove('sb-recs--pending');

        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        }
      }

      initializeReviews() {
        if (!this.querySelector('.shopify-product-reviews-badge') || !window.SPR) return;

        const methods = [
          'registerCallbacks',
          'initRatingHandler',
          'initDomEls',
          'loadProducts',
          'loadBadges'
        ];

        methods.forEach(method => {
          if (typeof window.SPR[method] === 'function') {
            window.SPR[method]();
          }
        });
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
